/**
 * 健康习惯版本切换埋点（P0-0.1，§6 度量行）
 *
 * SDK（sa-sdk-javascript）已在 src/app.js 初始化，但全仓此前 0 处调用（§1.1）。
 * 这里的原则：埋点绝不影响页面 —— 任何异常都静默吞掉，只留 console。
 */
import sensors from 'sa-sdk-javascript';

export const HABIT_VERSION_SWITCH_EVENT = 'habit_version_switch';

/**
 * @param {object} payload
 * @param {string} payload.from    切换前版本
 * @param {string} payload.to      切换后版本
 * @param {string|number} payload.userId  被查看的用户（不是操作人；操作人由服务端日志侧携带）
 * @param {string} payload.source  决策来源（LOCAL_OVERRIDE / SERVER_DEFAULT / DEGRADED / ...）
 * @param {string} [payload.trigger]  user / auto_degrade / server_default
 * @param {string} [payload.reason]   降级或不可用原因
 * @param {string} [payload.engineVersion] v2 判定载荷字段，P1 起才有
 * @param {string} [payload.bundleVersion] 前端包版本，P1 起随构建注入
 */
export function trackVersionSwitch(payload = {}) {
  try {
    if (!sensors || typeof sensors.track !== 'function') return false;
    const {
      from,
      to,
      userId,
      source,
      trigger,
      reason,
      engineVersion,
      bundleVersion,
    } = payload;
    sensors.track(HABIT_VERSION_SWITCH_EVENT, {
      from_version: from || null,
      to_version: to || null,
      target_user_id:
        userId === undefined || userId === null ? null : String(userId),
      decision_source: source || null,
      trigger: trigger || 'user',
      reason: reason || null,
      engine_version: engineVersion || null,
      bundle_version: bundleVersion || null,
    });
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('habit_version_switch 埋点失败（不影响页面）', error);
    return false;
  }
}

export const HABIT_UNKNOWN_BUCKET_EVENT = 'habit_unknown_bucket';

/**
 * 服务端下发了前端没有模板的桶码。
 *
 * 必须上报，因为处理策略是"忽略 + 继续渲染"：不报的话，一个码可以在生产上静默消失好几周，
 * 而它对应的那部分用户正好是这次改版想讲的人。带上 dimension 与 engineVersion，
 * 这样"该补哪个模板"能直接从埋点查出来，不用去翻服务端日志。
 */
export function trackUnknownBuckets({
  codes,
  dimension,
  userId,
  engineVersion,
} = {}) {
  const list = Array.isArray(codes) ? codes.filter(Boolean) : [];
  if (!list.length) return false;
  try {
    if (!sensors || typeof sensors.track !== 'function') return false;
    sensors.track(HABIT_UNKNOWN_BUCKET_EVENT, {
      unknown_codes: list.join(','),
      dimension: dimension || null,
      target_user_id:
        userId === undefined || userId === null ? null : String(userId),
      engine_version: engineVersion || null,
    });
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('habit_unknown_bucket 埋点失败（不影响页面）', error);
    return false;
  }
}
